// src/lib/textNorm.js — normalização de descrições (anti "festival" de caixa alta/baixa).
// Regra CONSERVADORA e sensível ao contexto:
//   • códigos (token com dígito: NF-397, 47433, R$100) e tokens com separador interno
//     (CP-II, S/A, 005/05) são preservados como estão;
//   • siglas conhecidas (NF, ORC, CD, CNPJ…) viram sempre maiúsculo canônico (inclusive se
//     vierem minúsculas: nf→NF, cd→CD);
//   • só rebaixa palavras GRITADAS quando a descrição INTEIRA está gritando (todas as palavras
//     "de verdade" em CAPS) — assim "COMPRA DE FERRAMENTA" vira "Compra de ferramenta", mas
//     uma sigla solta no meio de texto normal (ex.: "Casa Teste BM") é preservada;
//   • capitaliza a 1ª letra do texto e a 1ª palavra descritiva após o bloco inicial de
//     código/sigla/separador.
// Espelho exato da função SQL public._norm_desc usada no backfill. Manter em sincronia.

const PRESERVA = new Set(['NF', 'NFE', 'NFS', 'NFSE', 'ORC', 'CP', 'CR', 'CD', 'CNPJ', 'CPF',
  'RG', 'PIX', 'EPI', 'RDO', 'BDI', 'DRE', 'IPI', 'ISS', 'ICMS', 'INSS', 'FGTS', 'PJ', 'PF',
  'LTDA', 'ME', 'EPP', 'EIRELI', 'RS']);

const EDGE = /^[.,:;—–\-()/·|]+|[.,:;—–\-()/·|]+$/g;
const INTERNAL_SEP = /[\-/.:·|]/;
const core = (t) => t.replace(EDGE, '');
const hasDigit = (t) => /\d/.test(t);
const cap1 = (s) => s.replace(/[^\W\d_]/u, (c) => c.toUpperCase());

function classify(t) {
  const c = core(t);
  const up = c.toUpperCase();
  const low = c.toLowerCase();
  const codeLike = c === '' || hasDigit(t) || INTERNAL_SEP.test(c);
  const sigla = PRESERVA.has(up);
  const allCaps = c !== '' && c === up && c !== low;
  const isWord = !codeLike && !sigla && c.length >= 2 && low !== up;
  return { c, up, low, codeLike, sigla, allCaps, isWord };
}

export function normalizeDescricao(input) {
  if (input == null) return input;
  const s = String(input).replace(/\s+/g, ' ').trim();
  if (!s) return s;
  const toks = s.split(' ');
  const info = toks.map(classify);
  const words = info.filter((x) => x.isWord);
  const shouting = words.length >= 1 && words.every((x) => x.allCaps);

  const out = toks.map((t, idx) => {
    const x = info[idx];
    if (x.codeLike) return t;
    if (x.sigla) return t.replace(x.c, x.up);
    if (shouting && x.allCaps && x.c.length >= 2) return t.replace(x.c, x.low);
    return t;
  });

  // 1ª palavra descritiva: pula códigos e siglas que rotulam um código à frente
  // (ex.: "NF 12424"), mas NÃO uma sigla que é o próprio assunto (ex.: "EPI e ...").
  let i = 0;
  while (i < out.length) {
    const x = classify(out[i]);
    if (x.codeLike) { i += 1; continue; }
    if (x.sigla) {
      const nxt = i + 1 < out.length ? classify(out[i + 1]) : null;
      if (nxt && nxt.codeLike) { i += 1; continue; }
    }
    break;
  }
  if (i < out.length) out[i] = cap1(out[i]);
  return cap1(out.join(' '));
}

export default normalizeDescricao;
